<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="推荐产品" name="first">
      <QyzsTjqy :tjcpID='tjcpID'></QyzsTjqy>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import QyzsTjqy from '../../../../../static/form/xsyz/QyzsTjqy'
export default {
  components: {
    QyzsTjqy
  },
  data()
  {
    return {
      activeName: '1',
      tjcpID: this.$route.query.id
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/QyzsCplbUpdate'})
      this.$store.commit('onActiveName', tab.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/QyzsCplbUpdate.vue